import type { Nullable } from 'corgi-types';

import type { FormData } from 'common/types/form';
import { FieldName } from '../components/enums';
import type { ContactFormFieldSlice, UserData } from '../components/types';
import { getComment, getImages } from './storage';

export const slicesIncludeField = (slices: ContactFormFieldSlice[], fieldName: FieldName) =>
  !!slices.find(slice => slice.fieldName === fieldName);

const getCommentValue = (slices: ContactFormFieldSlice[]) =>
  slicesIncludeField(slices, FieldName.Comment) ? getComment() : '';

const getImagesValue = (slices: ContactFormFieldSlice[]) =>
  slicesIncludeField(slices, FieldName.Images) ? getImages() : '';

const getProductName = (skuFromUrl: Nullable<string>) =>
  skuFromUrl ? [FieldName.ProductName, skuFromUrl] : null;

const getOrderId = (orderIdFromUrl: Nullable<string>) =>
  orderIdFromUrl ? [FieldName.OrderId, orderIdFromUrl] : null;

const getOrderNumber = (orderIdFromUrl: Nullable<string>) =>
  orderIdFromUrl ? [FieldName.OrderNumber, orderIdFromUrl] : null;

export const getInitialFormData = ({
  user,
  slices,
  skuFromUrl,
  orderIdFromUrl,
}: {
  user: Nullable<UserData>;
  slices: ContactFormFieldSlice[];
  skuFromUrl: Nullable<string>;
  orderIdFromUrl: Nullable<string>;
}): FormData<FieldName> =>
  new Map(
    [
      [FieldName.FirstName, user?.firstName ?? ''],
      [FieldName.LastName, user?.lastName ?? ''],
      [FieldName.EmailAddress, user?.email ?? ''],
      [FieldName.Phone, user?.telephone ?? ''],
      [FieldName.Comment, getCommentValue(slices)],
      [FieldName.Images, getImagesValue(slices)],
      getProductName(skuFromUrl),
      getOrderId(orderIdFromUrl),
      getOrderNumber(orderIdFromUrl),
    ].filter((entry): entry is [FieldName, string] => entry !== null)
  );

export const getCustomerNumber = (user: Nullable<UserData>) => user?.uid ?? null;
